// custom-multi-select.js
(() => {
    const openedSelectClass = 'custom-multi-select_opened'
    const optionSelectedClass = 'custom-multi-select__option_selected'
    const errorMessageShownClass = 'custom-multi-select__error_shown'

    const selects = document.querySelectorAll(".custom-multi-select")
    selects.forEach(select => {
        if (!select) return

        const input = select.querySelector('.custom-multi-select__input')
        const optionsBox = select.querySelector('.custom-multi-select__options-box')
        if (!input || !optionsBox) return

        const options = optionsBox.querySelectorAll('.custom-multi-select__option')
        
        const label = select.querySelector('.custom-multi-select__label')
        const current = select.querySelector('.custom-multi-select__current')
        const errorMessage = select.querySelector('.custom-multi-select__error')
        if (!label || !current) return

        const defaultCountText = select.dataset.defaultCountText
        const selectedCountText = select.dataset.selectedCountText

        init()
        updateCountText()

        current.addEventListener('click', () => {
            select.classList.toggle(openedSelectClass)
        })

        options.forEach(option => {
            option.addEventListener('click', () => {
                const optionId = option.dataset.optionId
                const idsArray = input.value ? input.value.split(' ') : []
                // console.log(idsArray.length, options.length)
                if (optionId === 'all') {
                    // if all checked
                    if (idsArray.length + 1 >= options.length) {
                        options.forEach(opt => opt.classList.remove(optionSelectedClass)) 
                    } else {
                        options.forEach(opt => opt.classList.add(optionSelectedClass)) 
                    }
                } else {
                    option.classList.toggle(optionSelectedClass)
                    if (!option.classList.contains(optionSelectedClass)) {
                        options[0].classList.remove(optionSelectedClass)
                    }
                }
                if (errorMessage) {
                    errorMessage.classList.remove(errorMessageShownClass)
                }
                updateInput()
                updateCountText()
            })
        })

        window.addEventListener('click', e => {
            if (e.target == select || select.contains(e.target)) return
            select.classList.remove(openedSelectClass)
        })

        function init() {
            const idsArray = input.value ? input.value.split(' ') : []
            options.forEach(option => {
                const optionId = option.dataset.optionId
                if (idsArray.includes(optionId)) {
                    option.classList.add(optionSelectedClass)
                } else {
                    options[0].classList.remove(optionSelectedClass)
                }
            })
        }

        function updateInput() {
            const idsArray = []
            options.forEach(option => {
                const optionId = option.dataset.optionId
                if (optionId !== 'all') {
                    if (option.classList.contains(optionSelectedClass)) {
                        idsArray.push(optionId)
                    }
                }
            })
            input.value = idsArray.join(' ')
        }

        function updateCountText() {
            const idsArray = input.value ? input.value.split(' ') : []
            
            if (idsArray.length) {
                label.innerText = `${selectedCountText} (${idsArray.length})`
            } else {
                label.innerText = defaultCountText
            }
        }
    })
})()